<template>
  <div class="contacts__info">
    <transition name="fade">
      <form
        @submit.prevent="$_sendForm"
        v-show="showForm"
        class="contacts__form"
        data-validate
        enctype="multipart/form-data">
        <div v-placeholder class="contacts__form__element contacts__form__element--full-width">
          <div class="contacts__from__element__placeholder">Tutti i campi sono obbligatori</div>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Nome</div>
          <input
            v-model="name"
            :class="{ 'errorinput': errors.has('name')}"
            name="name"
            type="text"
            v-validate="'required'">
          <span class="contacts__form__element_error">{{ errors.first('name') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Cognome</div>
          <input
            v-model="surname"
            :class="{ 'errorinput': errors.has('surname')}"
            name="surname"
            type="text"
            v-validate="'required'">
          <span class="contacts__form__element_error">{{ errors.first('surname') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Email</div>
          <input
            v-model="email"
            :class="{ 'errorinput': errors.has('email')}"
            name="email"
            type="text"
            v-validate="'required|email'">
          <span class="contacts__form__element_error">{{ errors.first('email') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Telefono</div>
          <input
            v-model="telephone"
            :class="{ 'errorinput': errors.has('telephone')}"
            name="telephone"
            type="text"
            v-validate="'required'">
          <span class="contacts__form__element_error">{{ errors.first('telephone') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Città</div>
          <input
            v-model="city"
            :class="{ 'errorinput': errors.has('city')}"
            name="city"
            type="text"
            v-validate="'required'">
          <span class="contacts__form__element_error">{{ errors.first('city') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Provincia</div>
          <select
            v-model="province"
            :class="{ 'errorinput': errors.has('province')}"
            name="province"
            v-validate="'required'">
            <option value=""></option>
            <option
              v-for="aProv of prov"
              :key="aProv"
              :value="aProv">
              {{ aProv }}
            </option>
          </select>
          <span class="contacts__form__element_error">{{ errors.first('province') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder">Posizioni aperte</div>
          <select
            v-model="career"
            :class="{ 'errorinput': errors.has('career')}"
            name="career"
            v-validate="'required'">
            <option value=""></option>
            <option
              v-for="aProv of positions"
              :key="aProv"
              :value="aProv">
              {{ aProv }}
            </option>
          </select>
          <span class="contacts__form__element_error">{{ errors.first('career') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element">
          <div class="contacts__from__element__placeholder" style="visibility:hidden">Curriculum (PDF)</div>
          <input
            type="file"
            @change="$_processFile($event)"
            placeholder="Curriculum"
            accept=".pdf"
            name="curriculum"
            v-validate="'required'">
          <span class="contacts__form__element_error">{{ errors.first('curriculum') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element contacts__form__element--full-width">
            <div class="contacts__from__element__placeholder">Messaggio</div>
            <input
              v-model="message"
              :class="{ 'errorinput': errors.has('message')}"
              name="message"
              type="text"
              v-validate="'required'">
            <span class="contacts__form__element_error">{{ errors.first('message') }}</span>
        </div>

        <div v-placeholder class="contacts__form__element contacts__form__element--checkbox contacts__form__element--no-margin">
          <input
            v-model="privacy"
            id="privacy"
            type="checkbox"
            name="privacy"
            v-validate="'required'">
          <label
            :class="{ 'errorinput': errors.has('privacy')}"
            for="privacy">
              <div>Acconsento all'uso dei miei dati come da <router-link :to="{ name: 'privacy' }">informativa</router-link></div>
          </label>
          <span class="contacts__form__element_error">{{ errors.first('privacy') }}</span>
        </div>

        <div class="contacts__form__element contacts__form__element--send-button">
          <button>Invia richiesta</button>
        </div>
      </form>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import { RemoteInstance } from 'directus-sdk-javascript'

export default {
  data: () => ({
    prov: ['Agrigento', 'Alessandria', 'Ancona', 'Arezzo', 'Ascoli Piceno', 'Asti', 'Avellino', 'Bari', 'Barletta-Andria-Trani', 'Belluno', 'Benevento', 'Bergamo', 'Biella', 'Bologna', 'Bolzano/Bozen', 'Brescia', 'Brindisi', 'Cagliari', 'Caltanissetta', 'Campobasso', 'Carbonia-Iglesias', 'Caserta', 'Catania', 'Catanzaro', 'Chieti', 'Como', 'Cosenza', 'Cremona', 'Crotone', 'Cuneo', 'Enna', 'Fermo', 'Ferrara', 'Firenze', 'Foggia', 'Forlì-Cesena', 'Frosinone', 'Genova', 'Gorizia', 'Grosseto', 'Imperia', 'Isernia', 'L\'Aquila', 'La Spezia', 'Latina', 'Lecce', 'Lecco', 'Livorno', 'Lodi', 'Lucca', 'Macerata', 'Mantova', 'Massa-Carrara', 'Matera', 'Medio Campidano', 'Messina', 'Milano', 'Modena', 'Monza e della Brianza', 'Napoli', 'Novara', 'Nuoro', 'Ogliastra', 'Olbia-Tempio', 'Oristano', 'Padova', 'Palermo', 'Parma', 'Pavia', 'Perugia', 'Pesaro e Urbino', 'Pescara', 'Piacenza', 'Pisa', 'Pistoia', 'Pordenone', 'Potenza', 'Prato', 'Ragusa', 'Ravenna', 'Reggio di Calabria', 'Reggio nell\'Emilia', 'Rieti', 'Rimini', 'Roma', 'Rovigo', 'Salerno', 'Sassari', 'Savona', 'Siena', 'Siracusa', 'Sondrio', 'Taranto', 'Teramo', 'Terni', 'Torino', 'Trapani', 'Trento', 'Treviso', 'Trieste', 'Udine', 'Valle d\'Aosta/Vallée d\'Aoste', 'Varese', 'Venezia', 'Verbano-Cusio-Ossola', 'Vercelli', 'Verona', 'Vibo Valentia', 'Vicenza', 'Viterbo'],
    positions: [
      'Tecnico di Laboratorio',
      'Tecnico di Ricerca',
      'Impiegato/a settore amministrativo',
      'Operatore Commerciale',
      'Commerciale Italia',
      'Commerciale Estero'
    ],
    email: '',
    name: '',
    surname: '',
    telephone: '',
    city: '',
    province: '',
    career: '',
    message: '',
    formSpedita: 'init',
    attachment: '',
    token: '',
    privacy: false
  }),
  computed: {
    formPostAction: {
      get () {
        return process.env.VUE_APP_MAILER + '/send'
      }
    },
    emailFrom: {
      get () {
        return process.env.VUE_APP_MAIL_FROM
      }
    },
    showForm: {
      get () {
        return this.formSpedita === 'init'
      }
    },
    showSuccess: {
      get () {
        return this.formSpedita === 'success'
      }
    },
    showFailure: {
      get () {
        return this.formSpedita === 'failure'
      }
    },
    compiled: {
      get () {
        return [
          this.name,
          this.surname,
          this.email,
          this.telephone,
          this.city,
          this.province,
          this.career,
          this.message,
          this.attachment
        ].every(field => field !== '')
      }
    }
  },
  async mounted () {
    try {
      await this.$quammServices.recaptcha.install()
    } catch (e) {
      // console.log('error', e)
    }
    this.token = await this.$quammServices.recaptcha.getToken()
  },
  methods: {
    $_processFile (event) {
      this.attachment = event.target.files[0]
      // trasformo in base64 https://codepen.io/AshV/pen/pjodjV
      const reader = new FileReader()
      reader.readAsBinaryString(this.attachment)
      reader.addEventListener('load', () => {
        const base64String = window.btoa(reader.result)
        this.attachment.base64 = base64String
      }, false)
    },
    async $_sendForm () {
      // validate inputs
      const validated = await this.$_validateBeforeSubmit()
      if (validated) {
        try {
          await axios.post(process.env.VUE_APP_POSTMAN_ENDPOINT + '/send/job', {
            data: {
              name: this.name,
              surname: this.surname,
              email: this.email,
              telephone: this.telephone,
              province: this.province,
              career: this.career,
              message: this.message,
              attachments: [{
                content: this.attachment.base64,
                type: 'application/pdf',
                filename: 'cv.pdf'
              }]
            }
          })

          return this.$router.push({ name: 'form-success' })
        } catch (e) {
          this.$router.push({ name: 'form-error' })
        }
      }
    },
    $_validateBeforeSubmit () {
      return this.$validator.validateAll()
    },
    async $_post (postData, attachment) {
      const directusClient = new RemoteInstance({
        url: process.env.VUE_APP_BACKEND_URL,
        version: process.env.VUE_APP_BACKEND_VERSION,
        accessToken: process.env.VUE_APP_USER_TOKEN
      })
      try {
        // file upload
        const responseString = await directusClient.createFile({
          title: attachment.name,
          name: attachment.name,
          type: attachment.type,
          tags: 'CV',
          data: attachment.base64 // Base64 file content
        })

        // table row
        const careersReply = await directusClient.createItem('careers', Object.assign({}, postData, { fileid: responseString.data.url }))
        return careersReply.meta.table === 'careers'
      } catch (e) {
        console.log('errore')
        console.log(e)
        return false
        // Raven.captureException(e)
      }
    }
  },
  directives: {
    placeholder: {
      bind (el) {
        el.classList.add('contacts__form__element--show-placeholder')

        const input = el.querySelector('input, select')
        if (input !== null) {
          input.addEventListener('focus', () => {
            el.classList.add('contacts__form__element--hide-placeholder')
          })

          input.addEventListener('blur', () => {
            if (input.value.trim() === '') {
              el.classList.remove('contacts__form__element--hide-placeholder')
            } else {
              el.classList.add('contacts__form__element--hide-placeholder')
            }
          })
        }
      }
    }
  }
}
</script>
